import '../../css/ShoppingCart/ShoppingCartLoading.css';

function ShoppingCartLoading({theme}) {
    return (
        <div className='jdkkwj234'>
            <div className={`jfkkkwie2 shimmer ${theme}`}></div>
            <div className={`dffertte3 shimmer ${theme}`}></div>
        </div>
    )
}

export default ShoppingCartLoading